import { Component, AfterViewInit, Input, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MatTableDataSource, MatDialog, PageEvent, MatPaginator } from '@angular/material';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { GatewayService } from 'src/app/gateway.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
// import { ReasignacionModalComponent } from './reasignacion-modal/reasignacion-modal.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { TipoServicioService } from '../tipo-servicio.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as L from 'leaflet';
import { MapaDialogComponent } from 'src/app/components/mapa-dialog/mapa-dialog.component';
import { DlgCitaprogramComponent } from 'src/app/home/citas-programadas/dlg-citaprogram/dlg-citaprogram.component';
import { BitacoraDialogComponent } from 'src/app/components/bitacora-dialog/bitacora-dialog.component';
@Component({
  selector: 'app-mapa-cita',
  templateUrl: './mapa-cita.component.html',
  styleUrls: ['./mapa-cita.component.scss']
})
export class MapaCitaComponent implements AfterViewInit, OnDestroy {

  private destroy$ = new Subject<void>();
  totalAlarmas = 5;
  puedeEditar = true;
  private markersLayer!: L.LayerGroup;

  provincias = [{
    idprovincia: 0,
    nombre: 'Todos'
  }];

  agentes = [{
    idagente: 0,
    nombre: 'Todos'
  }];

  agentesFiltrados: any[] = [];
  searchTecnico = '';

  contratas = [{
    iddistribuidor: 0,
    nombre: 'Todos'
  }];

  tiempos = [
    {
      id: 0,
      name: 'Todos'
    },
    {
      id: 'AM',
      name: 'AM'
    },
    {
      id: 'PM',
      name: 'PM'
    }
  ];

  modoMapa: 'CITAS' | 'ALARMAS' = 'CITAS';
  alarmasMapa: any[] = [];
  alarmasMapaFiltradas: any[] = [];
  total_alarmas = 0;
  total_alarmas1 = 0;
  total_alarmas2 = 0;
  total_alarmas3 = 0;
  total_alarmas4 = 0;
  totales_altec: any = {};

  grupoVal = new FormGroup({
    FECHA: new FormControl(''),
    ESTADO: new FormControl(''),
    PRIORIDAD: new FormControl(null),
    CONTRATA_TECNICO: new FormControl([]),
    AM_PM: new FormControl(0),
    CONTRATA: new FormControl(0),
    TECNICO: new FormControl(0),
    PROVINCIA: new FormControl(0),
    ORDEN: new FormControl(''),
    TIPO_ALARMA: new FormControl([]),
  });

  citas: any[] = [];
  citas_asignadas = 0;
  citas_encamino = 0;
  citas_encurso = 0;
  citas_completado = 0;
  citas_sinasignacion = 0;
  citas_sincoordenadas = 0;
  ordenes_sincita = 0;
  isOpen = false;

  @ViewChild('mapa') mapaContainer!: ElementRef;
  private map!: L.Map;

  tableColumns: string[] = ['FECHA_HORA', 'TIPO_ALARMA', 'DETALLE'];
  dataSource = new MatTableDataSource<any>([]);
  allAlarmasTabla: any[] = [];
  allTotalesAltec: any = { total: 0 };
  private subscription: Subscription;
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;
  FILTER; resultsLength = 0;
  pageSize = 10;
  idpais;
  pageEvent: PageEvent
  public actpage: number = 0;
  @ViewChild('paginatortable') paginatortable: MatPaginator;
  contratasagente = [];
  prioridades = [];
  private legendControl: L.Control | null = null;

  // Toggle Instalacion/Reparacion
  selectedDistribuidor: number;  // 41 = Instalaciones, 44 = Reparaciones
  selectedArea: number;          // 14 = Instalaciones, 15 = Reparaciones

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private _tipoServicio: TipoServicioService
  ) {
    const tipoActual = this._tipoServicio.getValorActual();
    this.selectedDistribuidor = tipoActual.IDU;
    this.selectedArea = tipoActual.IDAREA;
    this.grupoVal.get('FECHA').setValue(new Date());
    this.filtrogeneral();
    this.getTecnicosxContrata();
    this.getProvincias();
    this.getContratasAgente();
    this.getPrioridades();
    this.get(0);
  }

  private _tienePermiso(modulo: string, tipo: string = 'ver'): boolean {
    const user = this.localSave.get('usuarioPGV');
    if (!user || !user.permisos) return false;
    const perm = user.permisos.find(p => p.modulo === modulo);
    return perm ? perm['permiso_' + tipo] === 1 : false;
  }

  ngAfterViewInit(): void {
    const user = this.localSave.get('usuarioPGV');
    if (user && user.idrol >= 28) {
      this.puedeEditar = this._tienePermiso('MAPA_CITAS', 'editar');
    }
    setTimeout(() => {
      this.initMap();
      this.loadCitas();
      this.addLegend();
    }, 0);

    this._tipoServicio.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data.IDU !== this.selectedDistribuidor || data.IDAREA !== this.selectedArea) {
        this.selectedDistribuidor = data.IDU;
        this.selectedArea = data.IDAREA;
        this.grupoVal.controls.CONTRATA_TECNICO.setValue([]);
        this.grupoVal.controls.TECNICO.setValue(0);
        this.getContratasAgente();
        this.getTecnicosxContrata();
        this.filtrogeneral();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.map) {
      this.map.remove();
    }
  }

  onModoMapaChange() {
    if (this.markersLayer) {
      this.markersLayer.clearLayers();
    }
    if (this.modoMapa == 'CITAS') {
      this.filtrogeneral();
      // this.get(0);
    } else {
      this.filtrogeneral();
      // this.get(0);
    }
    this.addLegend();
  }

  limpiarFiltros() {
    this.grupoVal.reset();
    this.grupoVal.controls.FECHA.setValue(new Date());
    this.grupoVal.controls.AM_PM.setValue(0);
    this.grupoVal.controls.TECNICO.setValue(0);
    this.grupoVal.controls.CONTRATA_TECNICO.setValue([]);
    this.grupoVal.controls.TIPO_ALARMA.setValue([]);
    this.grupoVal.controls.ORDEN.setValue('');
    const tipoActual = this._tipoServicio.getValorActual();
    this.selectedDistribuidor = tipoActual.IDU;
    this.selectedArea = tipoActual.IDAREA;
    this.getContratasAgente();
    this.getTecnicosxContrata();
    this.filtrogeneral();
  }

  /** Devuelve el valor de CONTRATA_TECNICO o null si está vacío */
  private getContrataValue(val?: any): any {
    const v = val !== undefined ? val : this.grupoVal.get('CONTRATA_TECNICO').value;
    return (Array.isArray(v) && v.length > 0) ? v : (v && !Array.isArray(v)) ? v : null;
  }

  /** Filtra la lista de técnicos según el texto de búsqueda */
  filtrarTecnicos() {
    const term = (this.searchTecnico || '').trim().toLowerCase();
    if (!term) {
      this.agentesFiltrados = this.agentes;
    } else {
      this.agentesFiltrados = this.agentes.filter(a =>
        a.nombre.toLowerCase().includes(term)
      );
    }
  }

  /** Limpia búsqueda al abrir/cerrar el dropdown de técnicos */
  onTecnicoDropdownToggle(opened: boolean) {
    if (opened) {
      this.searchTecnico = '';
      this.filtrarTecnicos();
    }
  }

  get(page) {
    this.gateway.get('getalarmasxarea',
      {
        num_elementos: this.pageSize,
        num_pagina: page,

        estados: this.grupoVal.get('ESTADO').value || [],
        fecha: this.grupoVal.get('FECHA').value || '',
        am_pm: this.grupoVal.get('AM_PM').value,
        idcontrata: this.grupoVal.get('CONTRATA').value,
        provincias: this.grupoVal.get('PROVINCIA').value,
        tecnicos: this.grupoVal.get('TECNICO').value,
        iddistribuidor: this.selectedDistribuidor || null,
        idarea: this.selectedArea || null,
        IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
        IDAREAAGENTE: this.localSave.get('usuarioPGV').IDAREAAGENTE,
        prioridad: this.grupoVal.get('PRIORIDAD').value,
      }).then((result) => {
        // console.log('getalarmasxarea:', JSON.stringify(result));
        let aux: any = result;
        this.allAlarmasTabla = aux.alarmas || [];
        this.alarmasMapa = aux.alarmas_mapa;
        this.allTotalesAltec = aux.totales || {};
        this.resultsLength = aux.length;
        this.filtrarAlarmasPorTipo();
        // console.log('alarmasMapa:', this.alarmasMapa);
        if (this.modoMapa == 'CITAS') {
        } else {
          this.loadAlarmasMapa();
          this.loadCitas(null, null);
        }

        // console.log({ NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais })
      }
      ).catch(function (e) {
      });
  }
  toggleBox() {
    this.isOpen = !this.isOpen;
  }

  filtrogeneral(latitud = null, longitud = null) {
    this.get(0);
    const params = {
      estados: this.grupoVal.get('ESTADO').value || [],
      fecha: this.grupoVal.get('FECHA').value || '',
      am_pm: this.grupoVal.get('AM_PM').value,
      idcontrata: this.grupoVal.get('CONTRATA').value,
      provincias: this.grupoVal.get('PROVINCIA').value,
      tecnicos: this.grupoVal.get('TECNICO').value,
      iddistribuidor: this.selectedDistribuidor || null,
      idarea: this.selectedArea || null,
      IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
      IDAREAAGENTE: this.localSave.get('usuarioPGV').IDAREAAGENTE,
      prioridad: this.grupoVal.get('PRIORIDAD').value,
      orden: this.grupoVal.get('ORDEN').value,
    };

    this.gateway.get('getubicacioncitas', params)
      .then((result) => {
        let aux: any = result;
        this.ordenes_sincita = aux.ordenes_sincita;
        aux = aux.citas;
        // console.log('Citas filtradas:', aux);

        // 🔹 Actualiza el arreglo de citas
        this.citas = aux || [];

        this.citas_asignadas = this.citas.filter(c => c.status_id == 2 && (c.lat != null && c.lat != '' && c.long != null && c.long != '')).length;
        this.citas_encamino = this.citas.filter(c => c.status_id == 3 && (c.lat != null && c.lat != '' && c.long != null && c.long != '')).length;
        this.citas_encurso = this.citas.filter(c => c.status_id == 4 && (c.lat != null && c.lat != '' && c.long != null && c.long != '')).length;
        this.citas_completado = this.citas.filter(c => c.status_id == 5 && (c.lat != null && c.lat != '' && c.long != null && c.long != '')).length;
        this.citas_sinasignacion = this.citas.filter(c => c.status_id == 1 && (c.lat != null && c.lat != '' && c.long != null && c.long != '')).length;
        this.citas_sincoordenadas = this.citas.filter(c => (c.lat == null || c.lat == '' || c.long == null || c.long == '')).length;

        // 🔹 Limpia los marcadores anteriores
        if (this.markersLayer) {
          this.markersLayer.clearLayers();
        }

        if (this.modoMapa == 'CITAS') {
          this.loadCitas(latitud, longitud);
        } else {
          // En modo ALARMAS, redibujar las alarmas despues de limpiar markersLayer
          // para evitar que la respuesta de getubicacioncitas borre los marcadores
          // que pinto getalarmasxarea (race condition).
          this.loadAlarmasMapa();
          this.loadCitas(latitud, longitud);
        }

      })
      .catch((e) => {
      });
  }

  getContratasAgente() {
    this.gateway.get('getContrata', { NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5, IDPAIS: this.idpais, IDAREA: this.selectedArea || null }).then((result) => {
      // console.log(result);
      let aux: any = result;
      this.contratasagente = aux.rows;
    }
    ).catch((e) => {
    });
  }

  getPrioridades() {
    this.gateway.get('getprioridades', {}).then((result) => {
      let aux: any = result;
      this.prioridades = aux;
    }
    ).catch(function (e) {
    });
  }

  getProvincias() {
    return new Promise((resolve, reject) => {
      this.gateway.get('getprovincias', {}).then((result) => {
        let aux: any = result;
        if (aux.rows.length > 0) {
          this.provincias = aux.rows;
          // this.provincias.unshift({ idprovincia: 0, nombre: 'Todos' });
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch((e) => {
        reject(e);
      });
    })
  }

  onProvinciaSeleccionada(event: any) {
    this.gateway.get('gettecnicosxcontrata', {
      IDPAIS: 5,
      IDDISTRIBUIDOR: this.selectedDistribuidor || null,
      IDPADRE: this.selectedDistribuidor || null,
      IDAREA: this.selectedArea || null,
      prioridad: this.grupoVal.get('PRIORIDAD').value,
      provincias: event.value,
      IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
    }).then((result) => {
      let aux: any = result;
      if (aux.rows.length > 0) {
        this.agentes = aux.rows;
        this.filtrarTecnicos();
      } else {
      }
    }).catch((e) => {
    });
  }

  onContrataSeleccionada(event: any) {
    // alert('Cargando técnicos de la contrata seleccionada...');
    this.gateway.get('gettecnicosxcontrata', {
      IDPAIS: 5,
      IDDISTRIBUIDOR: this.selectedDistribuidor || null,
      IDPADRE: this.selectedDistribuidor || null,
      IDAREA: this.selectedArea || null,
      provincias: this.grupoVal.get('PROVINCIA').value,
      IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(event.value),
    }).then((result) => {
      let aux: any = result;
      if (aux.rows.length > 0) {
        this.agentes = aux.rows;
        this.filtrarTecnicos();
      } else {
      }
    }).catch((e) => {
    });
  }

  getTecnicosxContrata() {
    return new Promise((resolve, reject) => {
      this.gateway.get('gettecnicosxcontrata', {
        IDPAIS: 5,
        IDDISTRIBUIDOR: this.selectedDistribuidor || null,
        IDPADRE: this.selectedDistribuidor || null,
        IDAREA: this.selectedArea || null,
        prioridad: this.grupoVal.get('PRIORIDAD').value,
        provincias: this.grupoVal.get('PROVINCIA').value,
        IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
      }).then((result) => {
        let aux: any = result;
        if (aux.rows.length > 0) {
          this.agentes = aux.rows;
          this.filtrarTecnicos();
          // this.agentes.unshift({ idagente: 0, nombre: 'Todos' });
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch((e) => {
        reject(e);
      });
    })
  }

  private initMap(): void {
    const container = this.mapaContainer.nativeElement;
    this.map = L.map(container);

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);

    // 🔹 Capa para los marcadores (para limpiarlos fácilmente)
    this.markersLayer = L.layerGroup().addTo(this.map);
  }

  private loadCitas(latitud = null, longitud = null): void {
    if (!this.citas || !this.citas.length) return;

    const tiposSeleccionados = this.grupoVal.get('TIPO_ALARMA').value || [];
    const mostrarSinTecnico = !tiposSeleccionados.length || tiposSeleccionados.includes('sin_tecnico');

    const bounds: L.LatLngBoundsExpression = [];

    this.citas.forEach(cita => {

      if (this.modoMapa == 'ALARMAS') {
        if (!mostrarSinTecnico && cita.status_id == 1) return;
        if (cita.status_id != 1) return;
      }

      const lat = parseFloat(cita.lat);
      const lon = parseFloat(cita.long);
      if (!lat || !lon) return;

      let iconHtml = '';
      let iconSize = 18;
      if (cita.status_id == 1 && mostrarSinTecnico) {
        iconHtml = `
          <style>
            @keyframes vibrarIcono {
              0%   { transform: rotate(0deg); }
              20%  { transform: rotate(-8deg); }
              40%  { transform: rotate(6deg); }
              60%  { transform: rotate(-5deg); }
              80%  { transform: rotate(4deg); }
              100% { transform: rotate(0deg); }
            }

            @keyframes sirenaIcono {
              0% {
                color: #ff4b4b;
                text-shadow: 0 0 4px rgba(255,0,0,0.5);
                transform: scale(1);
              }
              50% {
                color: #ff0000;
                text-shadow:
                  0 0 10px rgba(255,0,0,0.9),
                  0 0 20px rgba(255,0,0,0.7);
                transform: scale(1.15);
              }
              100% {
                color: #ff4b4b;
                text-shadow: 0 0 4px rgba(255,0,0,0.5);
                transform: scale(1);
              }
            }
          </style>

          <div style="
            font-size:${iconSize}px;
            color:red;
            text-shadow: 1px 1px 2px #000;
            display:flex;
            align-items:center;
            justify-content:center;
            animation:
              vibrarIcono 0.4s ease-in-out infinite,
              sirenaIcono 1.2s ease-in-out infinite;
          ">
            ⛔
          </div>
        `;
      }
      else {
        // 🔵 Marcador de color para otros estados
        const color = this.getColorByStatus(cita.status_id);
        iconHtml = `
        <div style="
          background-color:${color};
          width:16px;height:16px;
          border-radius:50%;
          border:2px solid white;
          box-shadow:0 0 2px #333;
        "></div>`;
      }

      const icon = L.divIcon({
        className: 'custom-marker',
        html: iconHtml
      });

      const marker = L.marker([lat, lon], { icon });

      marker.bindPopup(`
        <b>${cita.status_name}</b><br>
        <b>ID Cita:</b> ${cita.idcita || ''}<br>
        <b>Orden:</b> ${cita.falla || ''}<br>
        <b>Prioridad:</b> ${cita.prioridad || ''}<br>
        <b>Dirección:</b> ${cita.address || ''}<br>
        <b>Técnico:</b> ${cita.tecnico || ''}<br>
        <b>Teléfono:</b> ${cita.telefono || ''}<br>
        <b>Contrata:</b> ${cita.contrata || ''}<br>
        <b>Fecha:</b> ${cita.date || ''} ${cita.am_pm || ''}<br>
        <b>Localización:</b>${cita.localizacion || ''}<br>
        <b>Supervisor:</b> ${cita.supervisor || ''}<br>
        <b>Tel. Supervisor:</b> ${cita.tel_supervisor || ''}<br>
        <b>Jefe:</b> ${cita.jefe || ''}<br>
        <b>Tel. Jefe:</b> ${cita.tel_jefe || ''}<br>
        <b>Lat:</b> ${lat.toFixed(6)}<br>
        <b>Lng:</b> ${lon.toFixed(6)}
        <br><br>

        ${(this.puedeEditar && !this.localSave.get('usuarioPGV').IDCONTRATA2 && (cita.status_id == 1 || cita.status_id == 2)) ? `
          <button id="edit-${cita.idcita}"
            style="
              background-color:#1976d2;
              color:white;
              border:none;
              border-radius:6px;
              padding:5px 10px;
              cursor:pointer;
              font-size:13px;
              margin-right:6px;
            ">
            📍 Editar
          </button>

          <button id="agendar-${cita.idcita}"
            style="
              background-color:#2e7d32;
              color:white;
              border:none;
              border-radius:6px;
              padding:5px 10px;
              cursor:pointer;
              font-size:13px;
              margin-right:6px;
            ">
            📅 Agendar
          </button>
        ` : ''}

        <button id="bitacora-${cita.idcita}"
          style="
            background-color:#ff6f00;
            color:white;
            border:none;
            border-radius:6px;
            padding:5px 10px;
            cursor:pointer;
            font-size:13px;
          ">
          📋 Bitácora
        </button>
      `);

      marker.on('popupopen', () => {

        const editBtn = document.getElementById(`edit-${cita.idcita}`);
        if (editBtn) {
          editBtn.addEventListener('click', () => {
            this.editMapaDialog(cita);
          });
        }

        const agendarBtn = document.getElementById(`agendar-${cita.idcita}`);
        if (agendarBtn) {
          agendarBtn.addEventListener('click', () => {
            this.agendarMapaDialog(cita);
          });
        }

        const bitacoraBtn = document.getElementById(`bitacora-${cita.idcita}`);
        if (bitacoraBtn) {
          bitacoraBtn.addEventListener('click', () => {
            this.bitacoraDialog(cita);
          });
        }

      });

      this.markersLayer.addLayer(marker);
      bounds.push([lat, lon]);
    });

    if (latitud == null && longitud == null) {
      if (bounds.length > 0) {
        this.map.fitBounds(bounds, { padding: [40, 40] });
      } else {
        this.map.setView([8.96, -79.70], 11);
      }
    } else {
      this.map.setView([latitud, longitud], 17);
    }
  }

  filtrarAlarmasPorTipo(): void {
    const tiposSeleccionados = this.grupoVal.get('TIPO_ALARMA').value || [];
    const hayFiltro = tiposSeleccionados && tiposSeleccionados.length > 0;

    // Filtrar alarmas del mapa
    let mapaFiltradas = this.alarmasMapa;
    if (hayFiltro) {
      mapaFiltradas = this.alarmasMapa.filter(al => {
        if (tiposSeleccionados.includes('sin_tecnico') && al.idtipo == 0) return true;
        if (tiposSeleccionados.includes('fuera_banda') && al.idtipo == 3) return true;
        if (tiposSeleccionados.includes('riesgo_am') && al.idtipo == 4 && al.cita && al.cita.am_pm == 'AM') return true;
        if (tiposSeleccionados.includes('riesgo_pm') && al.idtipo == 4 && al.cita && al.cita.am_pm == 'PM') return true;
        if (tiposSeleccionados.includes('alarma_tecnico') && al.idtipo == 100) return true;
        if (tiposSeleccionados.includes('alarma_provincia') && (al.idtipo == 1 || al.idtipo == 2)) return true;
        return false;
      });
    }

    // Recalcular totales desde mapa filtrado
    this.total_alarmas1 = 0;
    this.total_alarmas2 = 0;
    this.total_alarmas3 = 0;
    this.total_alarmas4 = 0;
    mapaFiltradas.forEach(a => {
      if (a.idtipo == 1) this.total_alarmas1++;
      else if (a.idtipo == 2) this.total_alarmas2++;
      else if (a.idtipo == 3) this.total_alarmas3++;
      else if (a.idtipo == 4) this.total_alarmas4++;
    });

    // Totales de tecnico
    if (hayFiltro && !tiposSeleccionados.includes('alarma_tecnico')) {
      this.totales_altec = { total: 0, tiempo_muerto: 0, sin_avance: 0, no_marca_camino: 0, no_marca_finalizada: 0, dos_dias_sin_actividad: 0 };
    } else {
      this.totales_altec = this.allTotalesAltec;
    }

    // Filtrar tabla de alarmas por tipo
    if (hayFiltro) {
      const tipoMap = {
        'sin_tecnico': ['sin tecnico', 'sin asignar'],
        'fuera_banda': ['fuera de banda'],
        'riesgo_am': ['riesgo'],
        'riesgo_pm': ['riesgo'],
        'alarma_tecnico': ['tiempo muerto', 'sin avance', 'no marca', 'no marca "en camino"', 'no marca "finalizada"', '2 dias sin actividad', '2 días sin actividad'],
        'alarma_provincia': ['sin programador', 'sin espacio', 'sin cupo']
      };
      const keywords = [];
      tiposSeleccionados.forEach(t => { if (tipoMap[t]) keywords.push(...tipoMap[t]); });
      this.dataSource.data = this.allAlarmasTabla.filter(a => {
        const tipo = (a.tipo || '').toLowerCase();
        return keywords.some(k => tipo.includes(k));
      });
    } else {
      this.dataSource.data = this.allAlarmasTabla;
    }

    // Citas sin asignacion filtrada
    let sinAsig = this.citas_sinasignacion || 0;
    if (hayFiltro && !tiposSeleccionados.includes('sin_tecnico')) sinAsig = 0;

    this.total_alarmas =
      sinAsig +
      (this.total_alarmas1 || 0) +
      (this.total_alarmas2 || 0) +
      (this.total_alarmas3 || 0) +
      (this.total_alarmas4 || 0) +
      (this.totales_altec.total || 0);

    this.resultsLength = this.dataSource.data.length;
  }

  private loadAlarmasMapa(): void {
    if (!this.alarmasMapa || !this.alarmasMapa.length) return;

    // Filtrar tabla y totales también
    this.filtrarAlarmasPorTipo();

    const tiposSeleccionados = this.grupoVal.get('TIPO_ALARMA').value || [];

    if (!tiposSeleccionados || tiposSeleccionados.length === 0) {
      this.alarmasMapaFiltradas = this.alarmasMapa;
    } else {
      this.alarmasMapaFiltradas = this.alarmasMapa.filter(al => {
        if (tiposSeleccionados.includes('sin_tecnico') && al.idtipo == 0) return true;
        if (tiposSeleccionados.includes('fuera_banda') && al.idtipo == 3) return true;
        if (tiposSeleccionados.includes('riesgo_am') && al.idtipo == 4 && al.cita && al.cita.am_pm == 'AM') return true;
        if (tiposSeleccionados.includes('riesgo_pm') && al.idtipo == 4 && al.cita && al.cita.am_pm == 'PM') return true;
        if (tiposSeleccionados.includes('alarma_tecnico') && al.idtipo == 100) return true;
        if (tiposSeleccionados.includes('alarma_provincia') && (al.idtipo == 1 || al.idtipo == 2)) return true;
        return false;
      });
    }

    const bounds: L.LatLngBoundsExpression = [];

    this.alarmasMapaFiltradas.forEach(al => {
      const lat = parseFloat(al.latitud);
      const lng = parseFloat(al.longitud);
      if (!lat || !lng) return;

      let icon = null;
      let marker = null;

      /*
      if (al.idtipo == 3) {
        icon = L.divIcon({
          className: 'custom-marker',
          html: `
              <div style="
                font-size:20px;
                color:#ff3b30;
                animation:pulseAlarm 1.3s infinite;
                text-shadow:0 0 10px rgba(255,0,0,.8);
              ">
                👷🏼
              </div>

              <style>
                @keyframes pulseAlarm {
                  0% { transform: scale(1); }
                  50% { transform: scale(1.25); }
                  100% { transform: scale(1); }
                }
              </style>
            `
        });
        marker = L.marker([lat, lng], { icon });
        marker.bindPopup(`
            <b>${al.tipo}</b><br>
            <b>Nombre:</b> ${al.tecnico_nombre}</br>
            <b>Correo:</b> ${al.correo}</br>
            <b>Telefono:</b> ${al.telefono}<br>
            <b>Contrata:</b> ${al.contrata}<br><br>
            ${al.descripcion}
        `);
      }
      */

      // ALARMAS DE CITAS FUERA DE BANDA
      if (al.idtipo == 3) {
        let iconSize = 18;
        icon = L.divIcon({
          className: 'custom-marker',
          html: `
          <style>
            @keyframes vibrarIcono {
              0%   { transform: rotate(0deg); }
              20%  { transform: rotate(-8deg); }
              40%  { transform: rotate(6deg); }
              60%  { transform: rotate(-5deg); }
              80%  { transform: rotate(4deg); }
              100% { transform: rotate(0deg); }
            }

            @keyframes sirenaIcono {
              0% {
                color: #ff4b4b;
                text-shadow: 0 0 4px rgba(255,0,0,0.5);
                transform: scale(1);
              }
              50% {
                color: #ff0000;
                text-shadow:
                  0 0 10px rgba(255,0,0,0.9),
                  0 0 20px rgba(255,0,0,0.7);
                transform: scale(1.15);
              }
              100% {
                color: #ff4b4b;
                text-shadow: 0 0 4px rgba(255,0,0,0.5);
                transform: scale(1);
              }
            }
          </style>

          <div style="
            font-size:${iconSize}px;
            color:red;
            text-shadow: 1px 1px 2px #000;
            display:flex;
            align-items:center;
            justify-content:center;
          ">
            ⏰
          </div>
        `});
        marker = L.marker([lat, lng], { icon });
        marker.bindPopup(`
            <b>${al.tipo}</b><br>
            <b>${al.cita.status_nombre || ''}</b><br>
            <b>ID Cita:</b> ${al.cita.idcita || ''}</br>
            <b>Prioridad:</b> ${al.cita.prioridad_nombre || ''}</br>
            <b>Dirección:</b> ${al.cita.address || ''}</br>
            <b>Técnico:</b> ${al.cita.tecnico_nombre || ''}</br>
            <b>Teléfono:</b> ${al.cita.telefono || ''}</br>
            <b>Contrata:</b> ${al.cita.contrata_nombre || ''}</br>
            <b>Fecha:</b> ${al.cita.date || ''} ${al.cita.am_pm || ''}</br>
            <b>Falla:</b> ${al.cita.falla || ''}</br>
            <b>Localización:</b> ${al.cita.localizacion || ''}</br>
            <b>Supervisor:</b> ${al.cita.supervisor || ''}</br>
            <b>Tel. Supervisor:</b> ${al.cita.tel_supervisor || ''}</br>
            <b>Jefe:</b> ${al.cita.jefe || ''}</br>
            <b>Tel. Jefe:</b> ${al.cita.tel_jefe || ''}</br>
            <b>Lat:</b> ${al.cita.latitud || ''}</br>
            <b>Lng:</b> ${al.cita.longitud || ''}</br>
            <br>
            ${al.descripcion || ''}
        `);
      }
      else if (al.idtipo == 4) {
        let iconSize = 18;
        icon = L.divIcon({
          className: 'custom-marker',
          html: `
          <style>
            @keyframes vibrarIcono {
              0%   { transform: rotate(0deg); }
              20%  { transform: rotate(-8deg); }
              40%  { transform: rotate(6deg); }
              60%  { transform: rotate(-5deg); }
              80%  { transform: rotate(4deg); }
              100% { transform: rotate(0deg); }
            }

            @keyframes sirenaIcono {
              0% {
                color: #ff4b4b;
                text-shadow: 0 0 4px rgba(255,0,0,0.5);
                transform: scale(1);
              }
              50% {
                color: #ff0000;
                text-shadow:
                  0 0 10px rgba(255,0,0,0.9),
                  0 0 20px rgba(255,0,0,0.7);
                transform: scale(1.15);
              }
              100% {
                color: #ff4b4b;
                text-shadow: 0 0 4px rgba(255,0,0,0.5);
                transform: scale(1);
              }
            }
          </style>

          <div style="
            font-size:${iconSize}px;
            color:red;
            text-shadow: 1px 1px 2px #000;
            display:flex;
            align-items:center;
            justify-content:center;
          ">
            ${al.cita.am_pm == 'AM' ? '🕚' : '⏳'}
          </div>
        `});
        marker = L.marker([lat, lng], { icon });
        marker.bindPopup(`
            <b>${al.tipo}</b><br>
            <b>${al.cita.status_nombre || ''}</b><br>
            <b>ID Cita:</b> ${al.cita.idcita || ''}</br>
            <b>Prioridad:</b> ${al.cita.prioridad_nombre || ''}</br>
            <b>Dirección:</b> ${al.cita.address || ''}</br>
            <b>Técnico:</b> ${al.cita.tecnico_nombre || ''}</br>
            <b>Teléfono:</b> ${al.cita.telefono || ''}</br>
            <b>Contrata:</b> ${al.cita.contrata_nombre || ''}</br>
            <b>Fecha:</b> ${al.cita.date || ''} ${al.cita.am_pm || ''}</br>
            <b>Falla:</b> ${al.cita.falla || ''}</br>
            <b>Localización:</b> ${al.cita.localizacion || ''}</br>
            <b>Supervisor:</b> ${al.cita.supervisor || ''}</br>
            <b>Tel. Supervisor:</b> ${al.cita.tel_supervisor || ''}</br>
            <b>Jefe:</b> ${al.cita.jefe || ''}</br>
            <b>Tel. Jefe:</b> ${al.cita.tel_jefe || ''}</br>
            <b>Lat:</b> ${al.cita.latitud || ''}</br>
            <b>Lng:</b> ${al.cita.longitud || ''}</br>
            <br>
            ${al.descripcion || ''}
        `);
      }
      else if (al.idtipo == 100) {
        icon = L.divIcon({
          className: 'custom-marker',
          html: `
              <div style="
                font-size:20px;
                color:#ff3b30;
                animation:pulseAlarm 1.3s infinite;
                text-shadow:0 0 10px rgba(255,0,0,.8);
              ">
                👷🏼
              </div>

              <style>
                @keyframes pulseAlarm {
                  0% { transform: scale(1); }
                  50% { transform: scale(1.25); }
                  100% { transform: scale(1); }
                }
              </style>
            `
        });
        marker = L.marker([lat, lng], { icon });
        let iconHtml = `
            <b>${al.tipo}</b><br>
            <b>Nombre:</b> ${al.tecnico.tecnico_nombre}</br>
            <b>Correo:</b> ${al.tecnico.correo}</br>
            <b>Telefono:</b> ${al.tecnico.telefono}<br>
            <b>Contrata:</b> ${al.tecnico.contrata}<br><br>
            
        `;
        // ${al.descripcion}<br>

        for (const alarma of al.alarmas) {
          iconHtml += `<b>${alarma.tipo}:</b> ${alarma.descripcion}<br><br>`;
        }
        marker.bindPopup(iconHtml);
      }
      else if (al.idtipo == 1 || al.idtipo == 2) {
        icon = L.divIcon({
          className: 'custom-marker',
          html: `
            <div style="
              font-size:20px;
              color:#ff3b30;
              text-shadow:0 0 10px rgba(255,0,0,.8);
            ">
              📍
            </div>

            <style>
              @keyframes pulseAlarm {
                0% { transform: scale(1); }
                50% { transform: scale(1.25); }
                100% { transform: scale(1); }
              }
            </style>
          `
        });
        marker = L.marker([lat, lng], { icon });
        marker.bindPopup(`
            <b>${al.tipo}</b><br>
            <b>Provincia:</b> ${al.provincia}</br>
            ${al.descripcion1 ? `<b>Alarma1:</b> ${al.descripcion1}<br><br>` : ''}
            ${al.descripcion2 ? `<b>Alarma2:</b> ${al.descripcion2}<br><br>` : ''}
            ${al.descripcion3 ? `<b>Alarma3:</b> ${al.descripcion3}<br><br>` : ''}
            ${al.descripcion4 ? `<b>Alarma4:</b> ${al.descripcion4}<br><br>` : ''}
            ${al.descripcion5 ? `<b>Alarma5:</b> ${al.descripcion5}<br><br>` : ''}
        `);
      }

      this.markersLayer.addLayer(marker);
      bounds.push([lat, lng]);
    });

    if (bounds.length > 0) {
      this.map.fitBounds(bounds, { padding: [40, 40] });
    }
  }

  editMapaDialog(cita): void {
    const dialogRef = this.dialog.open(MapaDialogComponent, {
      width: '80%',
      data: {
        provincia: null,
        lat: parseFloat(cita.lat),
        lng: parseFloat(cita.long),
        cita: cita
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result) {
        this.filtrogeneral(result.lat, result.lng);
      }
    });
  }

  bitacoraDialog(cita: any): void {
    this.dialog.open(BitacoraDialogComponent, {
      width: '80%',
      panelClass: 'bitacora-dialog-panel',
      data: {
        cita: cita
      }
    });
  }

  agendarMapaDialog(cita: any) {
    cita['fecha_visita'] = cita.date;
    cita['idestado'] = cita.status_id;
    this.dialog.open(DlgCitaprogramComponent, {
      width: '80%',
      disableClose: true,
      data: {
        operacion: 'Editar',
        agente: cita
      }
    }).afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result) {
        this.onModoMapaChange();
      }
    });
  }

  /** 🎨 Colores según el estado **/
  private getColorByStatus(statusId: number): string {
    switch (statusId) {
      case 1: return '#808080'; // Gris → Ordenes de trabajo sin técnico
      case 2: return '#2b00ffff'; // Azul → Asignada
      case 3: return '#ffc107'; // Amarillo → Técnico en camino
      case 4: return '#0ed2f0ff'; // Celeste → Técnico en sitio
      case 5: return '#28a745'; // Verde → Finalizado
      default: return '#6c757d'; // Gris oscuro (desconocido)
    }
  }

  private addLegend(): void {
    const modo = this.modoMapa;

    // 🔴 Eliminar leyenda anterior
    if (this.legendControl) {
      this.map.removeControl(this.legendControl);
    }

    const legend = L.control({ position: 'bottomright' });

    legend.onAdd = () => {
      const div = L.DomUtil.create('div', 'info legend');

      // 🔹 Definir estados según modo
      const estados =
        modo === 'CITAS'
          ? [
            { id: 1, name: 'Órdenes de trabajo sin técnico', color: '#ff3b30', icon: '⛔' },
            { id: 2, name: 'Asignada', color: '#2b00ff' },
            { id: 3, name: 'Técnico en camino', color: '#ffc107' },
            { id: 4, name: 'Técnico en sitio', color: '#0ed2f0' },
            { id: 5, name: 'Finalizado', color: '#28a745' }
          ]
          : [
            { id: 1, name: 'Órdenes de trabajo sin técnico', color: '#ff3b30', icon: '⛔' },
            { id: 2, name: 'Órdenes de trabajo fuera de banda', color: '#ff3b30', icon: '⏰' },
            { id: 3, name: 'Órdenes de trabajo en riesgo AM', color: '#ff3b30', icon: '🕚' },
            { id: 4, name: 'Órdenes de trabajo en riesgo PM', color: '#ff3b30', icon: '⏳' },
            { id: 5, name: 'Alarmas de técnico', color: '#2b00ff', icon: '👷🏼' },
            { id: 6, name: 'Alarmas de provincia', color: '#2b00ff', icon: '📍' }
          ];

      div.innerHTML = `
      <!-- BOTÓN -->
      <div id="legend-btn" style="
        background:#ffffff;
        padding:8px 12px;
        border-radius:999px;
        box-shadow:0 6px 14px rgba(0,0,0,0.25);
        cursor:pointer;
        display:flex;
        align-items:center;
        gap:6px;
        font-size:13px;
        font-weight:600;
        margin-bottom:8px;
      ">
        ${modo === 'ALARMAS' ? '🚨 Alarmas' : '📍 Estados'}
      </div>

      <!-- PANEL (ABIERTO AL INICIO) -->
      <div id="legend-panel" style="
        position:absolute;
        bottom:44px;
        right:0;
        background:#ffffff;
        border-radius:12px;
        box-shadow:0 8px 22px rgba(0,0,0,0.3);
        font-size:13px;
        min-width:220px;
        padding:12px 14px;
        display:block;
      ">
        <div style="
          display:flex;
          justify-content:space-between;
          align-items:center;
          font-weight:700;
          margin-bottom:10px;
        ">
          <span>${modo === 'ALARMAS' ? '🚨 Alarmas' : '📍 Estados'}</span>
          <span id="legend-close" style="cursor:pointer;font-size:16px;">✕</span>
        </div>

        ${estados.map(e => {
        if (e.icon) {
          return `
              <div style="
                display:flex;
                align-items:center;
                margin-bottom:8px;
                font-weight:600;
                color:#c62828;
              ">
                <span style="
                  font-size:18px;
                  margin-right:10px;
                  animation: pulseRed 1.2s ease-in-out infinite;
                ">${e.icon}</span>
                ${e.name}
              </div>
            `;
        }

        return `
            <div style="
              display:flex;
              align-items:center;
              margin-bottom:8px;
            ">
              <span style="
                background:${e.color};
                width:16px;
                height:16px;
                border-radius:50%;
                display:inline-block;
                margin-right:10px;
              "></span>
              ${e.name}
            </div>
          `;
      }).join('')}

        <style>
          @keyframes pulseRed {
            0% { transform: scale(1); }
            50% { transform: scale(1.15); }
            100% { transform: scale(1); }
          }
        </style>
      </div>
    `;

      setTimeout(() => {
        const btn = div.querySelector('#legend-btn') as HTMLElement;
        const panel = div.querySelector('#legend-panel') as HTMLElement;
        const close = div.querySelector('#legend-close') as HTMLElement;

        btn.onclick = () => panel.style.display = 'block';
        close.onclick = () => panel.style.display = 'none';
      });

      return div;
    };

    legend.addTo(this.map);
    this.legendControl = legend;
  }

}

